import React, { Component } from "react";
import { connect } from 'react-redux';
import { actions } from 'react-redux-form';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { SelectFieldFloatingLabel as Select, InputFieldFloatingLabel as InputField } from "../../../../../../common/custom-form/select-filter.component";
import { MAX_LENGTH, DATA_TYPE } from "../../../../../../../constants/external-constants";
import CustomSearchableSelectWrapper from "../../../../../../common/custom-form/custom-searchable-select-wrapper.component";
import { TabberButton } from "../../../../../../common/custom-form/tabber-button.component";
import { TRANSLATIONS as translation } from "../../../../../../../utils/constant.utils";
import { articleCatalogueMilestoneActions } from "../../../../../../../store/external/recharge-reducer/article-catalogue-milestone.reducer/article-catalogue-milestone.reducer";
import CustomSearchableDropdownWrapper from "../../../../../../common/custom-form/custom-dropdown/custom-searchable-dropdown-wrapper";

class Article extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isTabberActive: !!props.alternateLogic,
            isAdditionalAttributeHidden: !props.alternateLogic,
            isFix: true,
            fixedFee: String(props.articleCatalogueMilestoneForm.fixedFee ?? ""),  // initialize from Redux
        };
        this.TabberButtonRef = React.createRef();
    }
   componentDidMount() {
        this.fetchArticleData();    
    }

    fetchArticleData = async () =>{
        this.props.getArticleCatalogueDropdownList();
        const { isAlternateLogic } = this.props.articleCatalogueMilestoneForm;
        this.toggleTabber(isAlternateLogic);
        this.setState({
            isTabberActive: !!this.props.alternateLogic,
            isAdditionalAttributeHidden: !this.props.alternateLogic,
            isFix: this.props.articleCatalogueMilestoneForm.priceCalculationId === '1' || this.props.articleCatalogueMilestoneForm.priceCalculationId === 1
        });

        if (this.props.articleCatalogueMilestoneForm.priceCalculationId === '2' || this.props.articleCatalogueMilestoneForm.priceCalculationId === 2) {
            this.props.FormChange('articleCatalogueMilestoneForm.fixedFee', '0.00');
        }

        if (this.props.articleCatalogueMilestoneForm.isAlternateLogic === true) {
            if (this.TabberButtonRef.current) {
                this.TabberButtonRef.current.toggle(this.props.articleCatalogueMilestoneForm.isAlternateLogic);
            }
        }

       

    }

    async componentDidUpdate(prevProps) {
        const { fixedFee } = this.props.articleCatalogueMilestoneForm;
        const { getSelectedCountryCode, getCountryCodeList } = this.props; 
        let selectedCountry = "";

        if (prevProps.articleCatalogueMilestoneForm.isAlternateLogic !== this.props.articleCatalogueMilestoneForm.isAlternateLogic) {
            if (this.TabberButtonRef.current) {
                this.TabberButtonRef.current.toggle(this.props.articleCatalogueMilestoneForm.isAlternateLogic);
            }
        }

        if (prevProps.articleCatalogueMilestoneForm.priceCalculationId !== this.props.articleCatalogueMilestoneForm.priceCalculationId) {
            this.setState({
                isFix: this.props.articleCatalogueMilestoneForm.priceCalculationId === '1' || this.props.articleCatalogueMilestoneForm.priceCalculationId === 1,
            });
        }

        if (prevProps.articleCatalogueMilestoneForm.countryId !== this.props.articleCatalogueMilestoneForm.countryId) {
            if (this.props.articleCatalogueMilestoneForm?.countryId) {
                selectedCountry = await getSelectedCountryCode(this.props.articleCatalogueMilestoneForm.countryId);
            }
            getCountryCodeList(1, selectedCountry);
        }
    }

    toLocaleLanguage = (key) => {
        const { locale } = this.props.translation;
        if (locale === null || locale === '' || locale === undefined)
            return translation[translation['defaultLocaleLanguage']][key];

        return translation[locale][key];
    }

    handleToggle = (isTabberActive) => {
        if (this.state.isTabberActive === isTabberActive) return; // Prevent loops

        this.props.FormChange('articleCatalogueMilestoneForm.isAlternateLogic', isTabberActive);
        this.setState({
            isTabberActive,
            isAdditionalAttributeHidden: !isTabberActive,
        });
    };

    onChangeSalesOrgSelection(e) {
        const { getSalesOrganizationDetails } = this.props;
        if (e != null) {
            getSalesOrganizationDetails(e);
        }
    }

    onChangePriceCalculation = (model, value) => {
        this.props.FormChange(model, value);
        this.props.updateDisabledButton(true, value);
        if (value === '1') {
            if (this.props.articleId === 0) {
                this.props.resetArticleComponentMilestoneForm();
                this.props.updateDisabledTab(0);
            }
            this.props.FormChange('articleCatalogueMilestoneForm.fixedFee', null);
            this.setState({
                isFix: true,
            });
        }
        else if (value === '2') {
            this.props.FormChange('articleCatalogueMilestoneForm.fixedFee', '0.00');
            this.setState({
                isFix: false,
            });
        }
    }  

    toggleTabber = (isTabberActive) => {
        if (this.state.isTabberActive === isTabberActive) return; // Avoid unnecessary updates

        this.props.FormChange("articleCatalogueMilestoneForm.isAlternateLogic", isTabberActive);

        if (!isTabberActive) {
            this.props.FormChange("articleCatalogueMilestoneForm.additionalAttribute", null);
        }

        this.setState({
            isTabberActive,
            isAdditionalAttributeHidden: !isTabberActive
        }, () => {
            if (this.TabberButtonRef.current) {
                this.TabberButtonRef.current.toggle(isTabberActive);
            }
        });
    };

    loadMoreCountryCode = (searchString) => {
        const { articleCatalogueMilestone, getCountryCodeList } = this.props;
            getCountryCodeList(articleCatalogueMilestone.countryCodePage + 1, searchString);
    }
     handleSearchCountryCode = (query) => {        
        const { getCountryCodeList } = this.props;
            getCountryCodeList(1, query);
    }

     loadMoreSalesOrganization = (searchString) => {
        const { articleCatalogueMilestone, getSalesOrganizationList } = this.props;
            getSalesOrganizationList(articleCatalogueMilestone.salesOrganizationPage + 1, searchString);
    }
     handleSearchSalesOrganization = (query) => {        
        const { getSalesOrganizationList } = this.props;
            getSalesOrganizationList(1, query);
    }

    render(){
        const { isActive } = this.state;
        const { articleCatalogueMilestone, articleCatalogueMilestoneForm, isArticleAlreadyExist, isViewing } = this.props;
        const disableFixedFee = this.props.articleCatalogueMilestoneForm.priceCalculationId === '1' || this.props.articleCatalogueMilestoneForm.priceCalculationId === 1;
        const isHidden = !this.props.articleCatalogueMilestoneForm.isAlternateLogic;
        return(
            <div className="grid-col-3 capital-uppercase">
                <InputField
                    className="form-control"
                    type="text"
                    label={this.toLocaleLanguage("article_number")}
                    value={articleCatalogueMilestoneForm.articleNumber}
                    fieldProp='.articleNumber'
                    maxLength={MAX_LENGTH.limit_20}
                    disabled={isViewing ?? false}
                    isError={isArticleAlreadyExist}
                    requiredField
                    placeholder={this.toLocaleLanguage("enter_text_placeholder")}
                />
                <InputField
                    className="form-control"
                    type="text"
                    label={this.toLocaleLanguage("article_name")}
                    value={articleCatalogueMilestoneForm.articleName}
                    fieldProp='.articleName'
                    maxLength={MAX_LENGTH.limit_255}
                    disabled={isViewing ?? false}
                    requiredField
                    placeholder={this.toLocaleLanguage("enter_text_placeholder")}
                />
                <InputField
                    className="form-control"
                    type="text"
                    label={this.toLocaleLanguage("service_family")}
                    value={articleCatalogueMilestoneForm.serviceFamily}
                    fieldProp='.serviceFamily'
                    maxLength={MAX_LENGTH.limit_255}
                    disabled={isViewing ?? false}
                    requiredField
                    placeholder={this.toLocaleLanguage("enter_text_placeholder")}
                />
                <CustomSearchableDropdownWrapper
                    className="form-control"
                    label={this.toLocaleLanguage("sales_organization_number").toUpperCase()}
                    options={articleCatalogueMilestone.salesOrganizationList}
                    selected={articleCatalogueMilestoneForm.salesOrganizationId}
                    onChange={(e) => this.onChangeSalesOrgSelection(e)}
                    isError={isArticleAlreadyExist}
                    requiredField
                    placeholder={this.toLocaleLanguage('select_placeholder')}
                    fieldProp='.salesOrganizationId'
                    tagName='key'
                    disabled={isViewing ?? false}
                    optionLabelKey={{
                        Key: "Key",
                        Value: "Value"
                    }}
                    maxLength={MAX_LENGTH.limit_10}
                    onSearchChange={this.handleSearchSalesOrganization}
                    onLoadMore={(val) => this.loadMoreSalesOrganization(val)}
                    isLoading={!this.props?.articleCatalogueMilestone?.isSalesOrganizationListLoaded}
                    hasMore={articleCatalogueMilestone?.hasMoreSalesOrgList}
                />
                <InputField
                    className="form-control"
                    type="text"
                    label={this.toLocaleLanguage("sales_organization_name")}
                    value={articleCatalogueMilestoneForm.salesOrganizationName}
                    fieldProp='.salesOrganizationName'
                    maxLength={MAX_LENGTH.limit_255}
                    disabled={true}
                    placeholder={this.toLocaleLanguage("enter_text_placeholder")}
                />
                <CustomSearchableDropdownWrapper 
                    className="form-control"
                    label={this.toLocaleLanguage("country_code").toUpperCase()}
                    options={articleCatalogueMilestone?.countryCodeList}
                    selected={articleCatalogueMilestoneForm.countryId}
                    onChange={() => {}}
                    isError={isArticleAlreadyExist}
                    requiredField
                    placeholder={this.toLocaleLanguage('select_placeholder')}
                    fieldProp='.countryId'
                    tagName='tagName'
                    disabled={isViewing ?? false}
                    optionLabelKey={{
                        Key: "Key",
                        Value: "Value"
                    }}
                    maxLength={MAX_LENGTH.limit_10}
                    onSearchChange={this.handleSearchCountryCode}
                    onLoadMore={(val) => this.loadMoreCountryCode(val)}
                    isLoading={!this.props?.articleCatalogueMilestone?.isCountryCodeLoaded}
                    hasMore={articleCatalogueMilestone?.hasMoreCountryCode}
                />
                <Select
                    className="form-select required"
                    label={this.toLocaleLanguage('price_calculation')}
                    options={articleCatalogueMilestone.articleCatalogueDropDownList.PriceCalculation}
                    value={articleCatalogueMilestoneForm.priceCalculationId}
                    placeholder={this.toLocaleLanguage('select_placeholder', false)}
                    isError={isArticleAlreadyExist}
                    fieldProp='.priceCalculationId'
                    optionLabelKey={{
                        Key: "Key",
                        Value: "Value"
                    }}
                    onChangeAction={this.onChangePriceCalculation}
                    disabled={isViewing ?? false}
                />
                <Select
                    className="form-select required"
                    label={this.toLocaleLanguage('vat_group')}
                    options={articleCatalogueMilestone.articleCatalogueDropDownList.VatGroup}
                    value={articleCatalogueMilestoneForm.vatGroupId}
                    placeholder={this.toLocaleLanguage('select_placeholder', false)}
                    isError={isArticleAlreadyExist}
                    fieldProp='.vatGroupId'
                    optionLabelKey={{
                        Key: "Key",
                        Value: "Value"
                    }}
                    onChange={(e) => this.props.FormChange('articleCatalogueMilestoneForm.vatGroupId', e.value)}
                    disabled={isViewing ?? false}
                />
                <InputField
                    className="form-control"
                    type="text"
                    label={this.toLocaleLanguage("pre_article_id")}
                    value={articleCatalogueMilestoneForm.preArticleId}
                    fieldProp='.preArticleId'
                    maxLength={MAX_LENGTH.limit_20}
                    disabled={isViewing ?? false}
                    placeholder={this.toLocaleLanguage("enter_text_placeholder")}
                />
                <Select
                    className="form-select required"
                    label={this.toLocaleLanguage('charge_type')}
                    options={articleCatalogueMilestone.articleCatalogueDropDownList.ChargeType}
                    value={articleCatalogueMilestoneForm.chargeTypeId}
                    placeholder={this.toLocaleLanguage('select_placeholder', false)}
                    isError={false}
                    fieldProp='.chargeTypeId'
                    optionLabelKey={{
                        Key: "Key",
                        Value: "Value"
                    }}
                    disabled={isViewing ?? false}
                />
                <InputField
                    className="form-control"
                    type="text"
                    label={this.toLocaleLanguage("price_unit")}
                    value={articleCatalogueMilestoneForm.priceUnit}
                    fieldProp='.priceUnit'
                    maxLength={MAX_LENGTH.limit_255}
                    disabled={isViewing ?? false}
                    placeholder={this.toLocaleLanguage("enter_text_placeholder")}
                />
                <Select
                    className="form-select required"
                    label={this.toLocaleLanguage('charge_category')}
                    options={articleCatalogueMilestone.articleCatalogueDropDownList.ChargeCategory}
                    value={articleCatalogueMilestoneForm.chargeCategoryId}
                    placeholder={this.toLocaleLanguage('select_placeholder', false)}
                    isError={false}
                    fieldProp='.chargeCategoryId'
                    optionLabelKey={{
                        Key: "Key",
                        Value: "Value"
                    }}
                    disabled={isViewing ?? false}
                />
                 <InputField
                    className="form-control required"
                    type="text"
                    label={this.toLocaleLanguage("fixed_fee")}
                    value={articleCatalogueMilestoneForm.fixedFee}
                    fieldProp="articleCatalogueMilestoneForm.fixedFee"
                    placeholder={this.toLocaleLanguage("enter_text_placeholder")}
                    inputType={DATA_TYPE.decimal}
                    maxLength={MAX_LENGTH.limit_21}
                    disabled={isViewing ?? !disableFixedFee}
                    requiredField={disableFixedFee}
                />

                <div className="tabber-form-container tabber-max-width">
                    <TabberButton
                        ref={this.TabberButtonRef}
                        title={this.toLocaleLanguage("alternate_logic")}
                        onToggle={this.toggleTabber}
                        isActive={this.state.isTabberActive}
                        disabled={isViewing}
                    />
                </div>
                <InputField
                    className="form-control"
                    type="text"
                    label={this.toLocaleLanguage("additional_attribute")}
                    value={articleCatalogueMilestoneForm.additionalAttribute}
                    fieldProp='.additionalAttribute'
                    maxLength={MAX_LENGTH.inputText}
                    disabled={isViewing ?? false}
                    hidden={isHidden}
                    isError={isArticleAlreadyExist}
                    requiredField
                    placeholder={this.toLocaleLanguage("enter_text_placeholder")}
                />
            </div>
        )
    }
}

export default withRouter(connect(
    state => {
        const {
            articleCatalogueMilestone
            , translation
            , form: { forms: { articleCatalogueMilestoneForm: { $form } } }
        } = state;
        const { articleCatalogueMilestoneForm } = state.form;
        return {
            translation
            , articleCatalogueMilestone
            , articleCatalogueMilestoneForm
            , $form
        };
    },
    dispatch => ({
        ...bindActionCreators(
            Object.assign({}, articleCatalogueMilestoneActions),
            dispatch
        ),
        FormChange: (model, value) => {
            dispatch(actions.change(model, value))
        }
    })
)(Article));